import {
  krpanoAutoBlank,
  krpanoEnterString,
  xmlString,
  xmlUrlString
} from '@/api/helpers'
import { isRtl } from '../../../../i18n/i18n-helper'
import linkImage from '../img/markers/link.png'
import memoImage from '../img/markers/memo.png'
import pointImage from '../img/markers/point.png'
import teleportImage from '../img/markers/teleport.png'
import tagImage from '../img/markers/tag.png'
import multitagImage from '../img/markers/multitag.png'
import galleryImage from '../img/markers/gallery.png'
import videoImage from '../img/markers/video.png'
import voiceImage from '../img/markers/voice.png'
import webImage from '../img/markers/web.png'
import stickerImage from '../img/markers/sticker.png'
import searchImage from '../img/markers/search.png'
import leftArrowImage from '../img/markers/arrows/left-arrow.png'
import rightArrowImage from '../img/markers/arrows/right-arrow.png'
import frontArrowImage from '../img/markers/arrows/front-arrow.png'
import leftFrontArrowImage from '../img/markers/arrows/left-front-arrow.png'
import rightFrontArrowImage from '../img/markers/arrows/right-front-arrow.png'
import upStairsArrowImage from '../img/markers/arrows/upstairs-arrow.png'
import downStairsArrowImage from '../img/markers/arrows/downstairs-arrow.png'
import pdfImage from '../img/markers/pdf.png'
import { HOTSPOT_BASE_SIZE } from '@/api/constants'
import { resizeImage } from '@/utils/resize'

const markerInfoCss = 'font-family:Noto Sans; color:#fff;'
const markerInfoCommonAttribute = 'scale="1" distorted="true" wordwrap="true" bgcolor="0x000000" bgalpha=".92"'
const markerAlpha = '.6'
const markerIconCommonAttribute = `zoom="true" distorted="true" scale="1" vr_timeout="700" keep="false" alpha="${markerAlpha}"`
const markerIconSize = `width="${HOTSPOT_BASE_SIZE}" height="prop"`

const getStylesXml = (panoramas, vrThumbAth, vrThumbWidth) => {
  let prev = '-1'
  let next = '+1'
  if (isRtl()) {
    prev = '+1'
    next = '-1'
  }
  let styles = `
    <style name="link" url="${linkImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="memo" url="${memoImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="point" url="${pointImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="teleport" url="${teleportImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="tag" url="${tagImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="gallery" url="${galleryImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="video" url="${videoImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="narration" url="${voiceImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="web" url="${webImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="pdf" url="${pdfImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="multitag" url="${multitagImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="sticker" url="${stickerImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="search" url="${searchImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="leftArrow" url="${leftArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="rightArrow" url="${rightArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="frontArrow" url="${frontArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="leftFrontArrow" url="${leftFrontArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="rightFrontArrow" url="${rightFrontArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="upstairsArrow" url="${upStairsArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />
    <style name="downstairsArrow" url="${downStairsArrowImage}" ${markerIconCommonAttribute} ${markerIconSize} />

    <style name="markerInfo"
      css="${markerInfoCss} font-size:16px;"
      padding="15"
      bg="true"
      ${markerInfoCommonAttribute} />
    <style name="markerInfoTag"
      ${markerInfoCommonAttribute}
      padding="0"
      bg="false"
      css="${markerInfoCss} font-size:14px;" />
    <style name="markerInfoTagBg"
      ${markerInfoCommonAttribute}
      bg="true"
      bgroundedge="30"
      css="${markerInfoCss} font-size:16px;" />
    <style name="markerButton"
      width="50"
      height="50"
      distorted="true"/>

    <!-- VR Menu -->
    <style name="vr_menu_style"
      depth="800"
      scale="0.2"
      distorted="true"
      ath="0"
      atv="45"
      visible="false" />
    <style name="vr_panorama_style"
      depth="800"
      distorted="true"
      keep="true"
      scale="0" />
    <hotspot name="vr_menu_bg"
      style="vr_menu_style"
      keep="true"
      zorder="5"
      bgcolor="0x000000"
      bgalpha=".8"
      bg="true"
      type="text"
      width="300"
      height="120"
      onover="vr_menu_over();"
      onout="vr_menu_out();"
      handcursor="false" />
    <hotspot name="vr_menu_l"
      style="vr_menu_style"
      keep="true"
      zorder="6"
      url="${require('../img/prev-panorama.png')}"
      width="60"
      height="60"
      ox="-20"
      onover="vr_menu_over(); delayedcall(0,tween(alpha,0.75,0.1));"
      onout="vr_menu_out();"
      vr_timeout="700"
      onclick="nextscene_loop(${prev});" />
    <hotspot name="vr_menu"
      style="vr_menu_style"
      keep="true"
      zorder="6"
      url="${require('../img/menu.png')}"
      width="60"
      height="60"
      onover="vr_menu_over(); delayedcall(0,tween(alpha,0.75,0.1));"
      onout="vr_menu_out();"
      vr_timeout="700"
      onclick="toggle_vr_menu(get('view.hlookat'));" />
    <hotspot name="vr_menu_r"
      style="vr_menu_style"
      keep="true"
      zorder="6"
      url="${require('../img/next-panorama.png')}"
      width="60"
      height="60"
      ox="+20"
      onover="vr_menu_over();
      delayedcall(0,tween(alpha,0.75,0.1));"
      onout="vr_menu_out();"
      vr_timeout="700"
      onclick="nextscene_loop(${next});" />
  `
  panoramas.forEach((panorama, index) => {
    const verticalCount = index % 4
    const horizontalCount = Math.floor(index / 4)
    // vr mode thumbnail
    const oy = (-(vrThumbWidth / 2 + 30) * 1.5) + (vrThumbWidth / 2 + 30) * (verticalCount)
    vrThumbAth = vrThumbAth * horizontalCount
    styles += `
      <hotspot name="vr_panorama_${index}"
        style="vr_panorama_style"
        zorder="6"
        url="${xmlUrlString(panorama.thumbnail)}"
        vr_timeout="2000"
        ath="${vrThumbAth}"
        oy="${oy}"
        width="${vrThumbWidth}"
        height="${vrThumbWidth / 2}"
        onclick="prepare_change_scene(panorama_${panorama.objectId}, ${panorama.objectId}, VrModeThumbnail)" />
      <hotspot name="vr_panorama_text_${index}"
        css="font-family:Noto Sans; color:#fff; font-size:12px; text-align: center; line-height: 18px;"
        type="text"
        html="${xmlString(krpanoAutoBlank(krpanoEnterString(panorama.customCategory || panorama.category), 10, true))}"
        vr_timeout="2000"
        style="vr_panorama_style"
        bgcolor="0x000000"
        bgalpha=".8"
        zorder="7"
        ath="${vrThumbAth}"
        oy="${oy + 50}"
        width="${vrThumbWidth}"
        height="20"
        onclick="prepare_change_scene(panorama_${panorama.panoramaId}, ${panorama.panoramaId}, 'VrModeThumbnailText')" />
    `

    // load all images from markers
    if (panorama.markers && panorama.markers.length) {
      panorama.markers.forEach(marker => {
        // Dynamic hotspot sizing: https://trello.com/c/9bTeL6Z0
        // Hide it first, then show it again after loading and resizing in `hotspot_loaded`
        const dynamicHotspotSizing = `
          visible="false"
          onloaded="hotspot_loaded(${marker.objectId});"
        `
        if (marker.useCustomIcon && marker.iconUrl) {
          const iconUrl = marker.disableResizing ? marker.iconUrl : resizeImage(marker.iconUrl)
          const customSize = `width="${HOTSPOT_BASE_SIZE}" height="prop"`
          // add custom icon image
          styles += `
            <style
              name="markerCustomIcon_${marker.objectId}"
              url="${xmlUrlString(iconUrl)}"
              ${dynamicHotspotSizing}
              ${markerIconCommonAttribute}
              ${customSize}/>
          `
        }
        if (marker.photo) {
          switch (marker.type) {
            case 'tag':
            case 'gallery':
              // define gallery styles
              styles += `<style
                name="markerInfoGalleryImage_${marker.objectId}"
                ${dynamicHotspotSizing}
                ${markerIconCommonAttribute}/>
              `
              break
            default:
              break
          }
        }
      })
    }
  })

  return styles
}

export default getStylesXml
